const blocks  = require('./blocks')

module.exports = {
  title: 'Cookie settings',
  save_settings_btn: 'Save current selection',
  accept_all_btn: 'ACCEPT ALL',
  reject_all_btn: 'Reject all',
  close_btn_label: 'Close',
  cookie_table_headers: [
      {col1: 'Name'},
      {col2: 'Domain'},
      {col3: 'Expiration'}
  ],
  blocks
}
